// @ts-nocheck
;(function () {
  if (window.__videoPauseControlBound) return
  window.__videoPauseControlBound = true

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches
  }

  function setPlayingUI(button, isPlaying) {
    const playLabel = window.theme?.strings?.accessibility?.play_video || 'Play video'
    const pauseLabel = window.theme?.strings?.accessibility?.pause_video || window.theme?.strings?.accessibility?.pause || 'Pause video'
    const label = isPlaying ? pauseLabel : playLabel

    button.setAttribute('data-status', isPlaying ? 'play' : 'pause')
    button.setAttribute('aria-label', label)
    const srOnlyEl = button.querySelector('.sr-only')
    if (srOnlyEl) srOnlyEl.textContent = label
  }

  function initWrapper(wrapper) {
    if (wrapper.dataset.videoPauseInit === '1') return
    const button = wrapper.querySelector('[data-video-pause]')
    const video = wrapper.getElementsByTagName('VIDEO')[0]
    if (!button || !video) return

    wrapper.dataset.videoPauseInit = '1'

    // Assume autoplay / playing UI unless reduced motion
    if (prefersReducedMotion()) {
      video.pause()
      setPlayingUI(button, false)
    } else if (button.getAttribute('data-status') === 'pause') {
      setPlayingUI(button, false)
    } else {
      setPlayingUI(button, true)
    }

    const videos = Array.from(wrapper.getElementsByTagName('VIDEO'))
    const handleToggle = (e) => {
      e.preventDefault()
      e.stopPropagation()
      const anyPlaying = videos.some((item) => !item.paused)
      if (anyPlaying) {
        videos.forEach((item) => {
          item.dataset.userPaused = '1'
          item.pause()
        })
        setPlayingUI(button, false)
      } else {
        videos.forEach((item) => {
          delete item.dataset.userPaused
          const playPromise = item.play()
          if (playPromise !== undefined) {
            playPromise.catch(() => setPlayingUI(button, false))
          }
        })
        setPlayingUI(button, true)
      }
    }

    const stopTouch = (e) => e.stopPropagation()
    button.addEventListener('click', handleToggle)
    button.addEventListener('touchstart', stopTouch, { passive: true })
    button.addEventListener('touchend', stopTouch, { passive: true })
  }

  function initAll(scope) {
    const root = scope || document
    root.querySelectorAll('[data-video-wrapper]').forEach(initWrapper)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll())
  } else {
    initAll()
  }

  document.addEventListener('shopify:section:load', (e) => {
    const sectionId = e.detail?.sectionId
    if (!sectionId) return
    const container =
      document.querySelector(`#shopify-section-${sectionId}`) ||
      document.querySelector(`[data-section-id="${sectionId}"]`)?.closest('.shopify-section')
    if (container) {
      container.querySelectorAll('[data-video-wrapper]').forEach((wrapper) => {
        delete wrapper.dataset.videoPauseInit
      })
      initAll(container)
    }
  })
})()
